import { DateService } from '@rocheglobal/component-library/src/services/date/index';
import React from 'react';
import { StringService } from '../../services';
import { parseAssetSource, parseDownloadSource } from '../props/asset';
import { Props } from '../types';

const Teaser = 'roche-teaser-global' as React.ReactType;

export const RocheDownloadTeaser = ({
  blok, slot,
}: Props): JSX.Element => {
  const teaserImage = blok?.teaser_image?.[0];
  const internalAsset = blok?.internal_asset?.filename;
  const externalAsset = blok?.external_asset;
  const publishingDate = blok?.publishing_date;
  const formattedDate = publishingDate && typeof document !== 'undefined'
    ? DateService.formatDate(publishingDate, { year: 'numeric', month: 'long', day: 'numeric' })
    : null;

  return (
    <Teaser
      layout={blok?.layout}
      teaser-title={blok?.teaser_title}
      teaser-overline={blok?.teaser_overline || formattedDate}
      teaser-description={StringService.getExtension(internalAsset || externalAsset).toUpperCase()}
      teaser-image={parseAssetSource(teaserImage?.src.filename)}
      teaser-url={parseDownloadSource(internalAsset) || externalAsset}
      is-download-link
      loaded={blok !== undefined}
      slot={slot}
    >
    </Teaser>
  );
};
